(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discovery-feed"] && !Shopify.designMode) return;
  try {
    
  async function loadDynamicDiscoveryItems() {
    const dynamicRows = document.querySelectorAll('.discovery-section--featured_products[data-dynamic="true"]');
    
    for (const row of dynamicRows) {
      const container = row.querySelector('.product-row-scroll');
      const skeleton = row.querySelector('.js-discovery-skeleton');
      const limit = parseInt(row.dataset.limit) || 8;

      if (skeleton) skeleton.style.display = '';
      if (container) container.style.display = 'none';

      const products = await window.SurpravAPI.getTrendingProducts(limit);

      if (skeleton) skeleton.style.display = 'none';
      if (container) container.style.display = '';

      if (products && products.length > 0) {
        console.log('Loaded dynamic products for discovery feed', products);
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', loadDynamicDiscoveryItems);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-category-menu"] && !Shopify.designMode) return;
  try {
    
  // Mobile category menu toggle
  document.addEventListener('DOMContentLoaded', () => {
    const mobileMenu = document.querySelector('[data-category-menu-mobile]');
    if (!mobileMenu) return;

    // Open via Mobile_Nav "Categorieën" button
    const toggleBtns = document.querySelectorAll('[data-mobile-menu-toggle], [data-menu-toggle]');
    toggleBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        mobileMenu.classList.add('is-open');
        mobileMenu.setAttribute('aria-hidden', 'false');
      });
    });

    // Close buttons
    const closeBtns = mobileMenu.querySelectorAll('[data-category-menu-close]');
    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
        mobileMenu.setAttribute('aria-hidden', 'true');
      });
    });

    // Accordion toggles for subcategories
    const accordionToggles = mobileMenu.querySelectorAll('[data-accordion-toggle]');
    accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const sublist = toggle.nextElementSibling;
        toggle.setAttribute('aria-expanded', String(!expanded));
        if (sublist) {
          sublist.hidden = expanded;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav-sticky"]) return;
  try {
    
  class MobileNavSticky extends HTMLElement {
    constructor() {
      super();
      
      this.triggers = this.querySelectorAll('.mobile-nav__trigger');
      this.init();
      this.initCartCount();
    }
    
    init() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const targetId = trigger.dataset.target;
          const panel = document.getElementById(targetId);
          
          if (panel) {
            this.openPanel(panel);
          }
        });
      });
    }
    
    openPanel(panel) {
      const backdrop = panel.querySelector('.mobile-panel__backdrop');
      const closeBtn = panel.querySelector('.mobile-panel__close');
      
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
      
      const closePanel = () => {
        panel.hidden = true;
        document.body.style.overflow = '';
      };
      
      backdrop.addEventListener('click', closePanel);
      closeBtn.addEventListener('click', closePanel);
      
      // Close on Escape
      const handleEscape = (e) => {
        if (e.key === 'Escape' && !panel.hidden) {
          closePanel();
          document.removeEventListener('keydown', handleEscape);
        }
      };
      
      document.addEventListener('keydown', handleEscape);
    }
    
    initCartCount() {
      // Listen to cart updates
      document.addEventListener('cart:updated', (e) => {
        const badge = this.querySelector('[data-cart-count]');
        if (badge && e.detail?.cart) {
          const count = e.detail.cart.item_count;
          
          if (count > 0) {
            badge.textContent = count;
            badge.style.display = 'flex';
          } else {
            badge.style.display = 'none';
          }
        }
      });
    }
  }
  
  if (!customElements.get('mobile-nav-sticky')) {
    customElements.define('mobile-nav-sticky', MobileNavSticky);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"] && !Shopify.designMode) return;
  try {
    
  // Dynamic notification check via App API
  async function checkNotifs() {
    const appUrl = window.__surprav?.appUrl;
    if (!appUrl) return;
    
    try {
      const res = await fetch(`${appUrl}/api/notifs?customerId=${window.__surprav.customerId}`);
      const data = await res.json();
      const badge = document.getElementById('notif-count');
      if (data.count > 0 && badge) {
        badge.style.display = 'flex';
      }
    } catch(e) {}
  }
  
  // Placeholder only: the notifications API currently always returns 0 and is
  // public. Auto-check disabled until real, customer-scoped notifications exist.
  // Re-enable by calling checkNotifs() once the backend is implemented.
  // document.addEventListener('DOMContentLoaded', checkNotifs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utility-bar"] && !Shopify.designMode) return;
  try {
    
  // Close utility-bar dropdown when clicking outside
  document.addEventListener('click', function(e) {
    var dropdowns = document.querySelectorAll('.utility-bar__dropdown[open]');
    for (var i = 0; i < dropdowns.length; i++) {
      if (!dropdowns[i].contains(e.target)) {
        dropdowns[i].removeAttribute('open');
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
